(function ($) {
    $(function () {
        let popup = $('.sitewide-popup');
        let cookieName = 'information-popup';

        if (popup.length === 0) {
            return;
        }

        setTimeout(function () {
            // Cookie exists?
            if (Cookies.get(cookieName) == 1) {
                return;
            }

            // Display popup on page load
            $.magnificPopup.open({
                items: {
                    src: popup,
                    type: 'inline'
                },
                showCloseBtn: false,
                closeOnBgClick: false,
            });

            // Remove the right margin from the HTML element.
            $('html').addClass('mr-0');

            // Close popup on button click
            $('#sitewide-popup-close-button').bind('click', function (e) {
                Cookies.set(cookieName, '1', {
                    // Set expiry to x hours.
                    expires: 2 / 24 // 2 hours
                });

                $.magnificPopup.close();
                $('html').removeClass('mr-0');
            });
        }, 250)
    });
})(jQuery);